
export const PageDataState = {
    Searchs: {
        name: {
            type: 'text',
            id: 'name',
            label: 'สิทธิประโยชน์',
            value: '',
            placeholder: 'สิทธิประโยชน์',
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'สิทธิประโยชน์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        genBenefitsCode: {
            type: 'text',
            id: 'genBenefitsCode',
            label: 'เลขสำหรับออกหลักสูตร',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 1,
                maxLength: 1
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}